// Core packages
import { NgModule } from '@angular/core';

// Third party packages

// Custom packages - Modules
import { PublicModule } from 'src/app/modules/public/public.module';
import { SharedModule } from '../shared.module';
import { HistoricalDocsRoutingModule } from './historical-docs-routing.module';

// Custom packages - Components
import { HistoricalDocsListComponent } from './pages/historical-docs-list.page';

@NgModule({
  imports: [
    // Shared modules
    SharedModule,

    // Custom
    HistoricalDocsRoutingModule,
    PublicModule,
  ],
  declarations: [
    HistoricalDocsListComponent,
  ],
  exports: [
  ]
})
export class HistoricalDocsModule { }
